export default function updateDocumentTitle(pathname) {
  let title = '';
  const path = pathname.split('/')[1];

  switch (path) {
    case 'reports':
      title = 'Reports';
      break;
    case 'report':
      title = 'Report';
      break;
    case 'imageeditor':
      title = 'Image Editor';
      break;
    case 'images':
      title = 'Images';
      break;
    default:
      title = 'Fluke';
      break;
  }
  document.title = title + ' | Baseline';
}
